var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 7.23687C16.6672 6.79488 16.4916 6.37103 16.179 6.05854L14.6557 4.53521C14.3432 4.22263 13.9193 4.04697 13.4773 4.04688H5.00065C4.55862 4.04688 4.1347 4.22247 3.82214 4.53503C3.50958 4.84759 3.33398 5.27151 3.33398 5.71354V15.7135C3.33398 16.1556 3.50958 16.5795 3.82214 16.8921C4.1347 17.2046 4.55862 17.3802 5.00065 17.3802H15.0007C15.4427 17.3802 15.8666 17.2046 16.1792 16.8921C16.4917 16.5795 16.6673 16.1556 16.6673 15.7135V7.23687Z",
    stroke: "#000095",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 4.04688V7.38021H6.66602V4.04688M6.66602 17.3802V10.7135H13.3327V17.3802",
    stroke: "#000095",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.dbbad48df77f77e42254f7aeb828f83f.svg";
export { ForwardRef as ReactComponent };